import "./loader.css";

export function Loader() {
  return <div className="boardLoader">Loading...</div>;
}
